//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CartIcon from '~/assets/icon/cart.svg?inline';
import BellIcon from '~/assets/icon/bell.svg?inline';
export default {
    components: { CartIcon, BellIcon },
    props: ['product'],
    data() {
        return {
            errors: [],
            disabled: [],
            selectedOptions: {},
            candidateProduct: null,
            qty: 1,
            mouseLeaveTimeout: null,
            showVariants: 6,
        };
    },
    computed: {
        isAllVariantsTheSamePrice() {
            let result = true;
            if (this.product.variants === undefined || this.product.variants.length === 0) {
                return result;
            }

            let lastFinalPrice = null;

            console.log(this.product.variants);
            this.product.variants.forEach((variant) => {
                let product = variant.product;
                let price = product.hasOwnProperty('price') ? product.price.regularPrice.amount.value : product.price_range.minimum_price.final_price.value;

                if (lastFinalPrice === null) {
                    lastFinalPrice = price;
                } else {
                    if (lastFinalPrice !== price) {
                        result = false;
                    }
                }
            });

            return result;
        },
        isAllVariantsOnSales() {
            let arr = {};
            this.product.configurable_options.forEach((option) => {
                arr[option.attribute_code] = 0;
                this.filterVariants(option).values.forEach((value) => {
                    if (this.isVariantOnSale(option.attribute_code, value.value_index)) {
                        arr[option.attribute_code] += 1;
                    }
                });
            });

            return Object.values(arr).indexOf(this.product.variants.length) !== -1;
        },
        addToCartDisabled() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;
            return product.stock_status === 'OUT_OF_STOCK';
        },
        priceTimesQty() {
            return this.$root.$options.filters.currencyValue(this.qty * this.product.price_range.minimum_price.final_price.value);
        },
        regularTierPrice() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;
            const catalogRules = product.applied_catalog_rules;

            if (!catalogRules || catalogRules.length === 0) {
                // No any discount rules
                return this.$root.$options.filters.currencyValue(this.qty * this.product.price_range.minimum_price.regular_price.value);
            }

            if (this.$store.state.auth?.user?.tukku_club?.group_info?.level_benefits) {
                // User has loyalty discount
                if (catalogRules.length >= 1) {
                    // Return price after regular discount as regular price
                    return this.$root.$options.filters.currencyValue(this.qty * catalogRules[0].new_price.value);
                } else {
                    return this.$root.$options.filters.currencyValue(this.qty * this.product.price_range.minimum_price.regular_price.value);
                }
            } else {
                return this.$root.$options.filters.currencyValue(this.qty * this.product.price_range.minimum_price.regular_price.value);
            }

            return this.priceTimesQty;
        },
    },
    watch: {
        selectedOptions: {
            deep: true,
            handler(newVal) {
                const selected = JSON.parse(JSON.stringify(newVal));
                if (Object.keys(selected)?.length === this.product.configurable_options?.length) {
                    const product = this.resolveVariant(this.product.variants, this.product, selected);
                    this.candidateProduct = product;
                    this.$root.$emit('candidateProduct', product);
                    this.$emit('configurableChange', product);
                }
            },
        },
    },
    methods: {
        isVariantOnSale(code, value) {
            const variant = this.findVariant(code, value);
            if (!variant) {
                return false;
            }

            if (!variant.product) {
                return false;
            }

            if (!variant.product.price_range) {
                return false;
            }

            if (!variant.product.price_range.minimum_price) {
                return false;
            }

            if (
                !variant.product.price_range.minimum_price.final_price
                || !variant.product.price_range.minimum_price.regular_price
            ) {
                return false;
            }

            return variant.product.price_range.minimum_price.final_price.value !== variant.product.price_range.minimum_price.regular_price.value;
        },
        onOptionMouseEnter(e) {
            const radio = e.target.querySelector('input');
            // Simulate click to activate correct watchers and switch the color option
            radio.dispatchEvent(new MouseEvent('click'));
        },
        onOptionClick() {
            if (this.$router) {
                const { selectedOptions: query } = this;
                this.$router.push({
                    path: this.localePath({
                        name: 'all',
                        params: { pathMatch: this.product.url_key },
                    }),
                    query,
                });
            }
        },
        onMouseLeave() {
            this.mouseLeaveTimeout = window.setTimeout(this.clearOptions, 1500);
        },
        onMouseEnter() {
            if (this.mouseLeaveTimeout) {
                window.clearTimeout(this.mouseLeaveTimeout);
                this.mouseLeaveTimeout = null;
            }
        },
        clearOptions() {
            this.selectedOptions = {};
            this.$emit('configurableChange', {});
        },
        filterVariants(option) {
            const filteredValues = option.values.filter((value) => this.findVariant(option.attribute_code, value.value_index) !== undefined);
            return {
                ...option,
                values: [...filteredValues],
            };
        },
        findVariant(code, value) {
            return [...this.product.variants].find((item) => item.attributes.find((attribute) => attribute.code === code && attribute.value_index === value));
        },

        imageAlt(code, value) {
            const matchProduct = [...this.product.variants].find((item) =>
                item.attributes.find((attribute) => attribute.code === code && attribute.value_index === value),
            );
            if (matchProduct.product?.thumbnail?.label) {
                return matchProduct.product.thumbnail?.label;
            } else {
                return matchProduct.attributes[0]?.label;
            }
        },
        resolveVariant(variants, configItem, selected) {
            this.disabled = [];
            const optionCodeMap = new Map();

            if (configItem) {
                configItem.configurable_options.forEach((option) => {
                    optionCodeMap.set(option.attribute_id, option.attribute_code);
                });
            }

            const mergedOptionSelections = new Map(Object.entries(selected));
            configItem.configurable_options.forEach((option) => {
                if (!mergedOptionSelections.has(`${option.id}`)) {
                    mergedOptionSelections.set(`${option.id}`, option.value_id);
                }
            });
            mergedOptionSelections.delete('undefined');
            const result = configItem.variants.find(({ attributes, product }) => {
                const customAttributes = (attributes || []).reduce((map, { code, value_index }) => new Map(map).set(code, value_index), new Map());

                for (const [id, value] of mergedOptionSelections) {
                    const code = optionCodeMap.get(id);
                    const matchesStandardAttribute = product[code] === value;
                    const matchesCustomAttribute = customAttributes.get(code) === value;

                    // if any option selection fails to match any standard attribute
                    // and also fails to match any custom attribute
                    // then this isn't the correct variant
                    if (!matchesStandardAttribute && !matchesCustomAttribute) {
                        return false;
                    }
                }

                // otherwise, every option selection matched
                // and this is the correct variant
                return product;
            });

            return result;
        },
        async submit(recursion) {
            const payload = {
                sku: this.product.sku,
                quantity: 1,
            };
            if (this.candidateProduct) {
                payload.sku = this.candidateProduct.product.sku;
                payload.parent_sku = this.product.sku;
            }
            this.errors = [];
            try {
                const { cart, user_errors } = await this.$store.dispatch('cart/addProduct', {
                    items: [payload],
                    product: this.candidateProduct || this.product,
                });
                this.errors = user_errors;
                if (!this.errors.length) {
                    this.$emit('productAdded');
                }
            } catch (e) {
                if (recursion) {
                    if (
                        e.message.startsWith('GraphQL error: Could not find a cart with ID') ||
                        e.message.startsWith('GraphQL error: The current user cannot perform operations on cart')
                    ) {
                        this.$storage.removeCookie('cart_id');
                        await this.$store.commit('cart/set_cart', {});
                        await this.$store.dispatch('cart/getCart');
                        await this.submit(true);
                    }
                } else {
                    this.$notify.error(e);
                }
            }
        },
    },
};
